export const MAP_UTILITIES_VEHICLE_LIST_SET = "MAP_UTILITIES_VEHICLE_LIST_SET";
export const MAP_UTILITIES_VEHICLE_LIST_HIDDEN_TAGS = "MAP_UTILITIES_VEHICLE_LIST_HIDDEN_TAGS";
export const MAP_UTILITIES_VEHICLE_LIST_REFRESH = "MAP_UTILITIES_VEHICLE_LIST_REFRESH";
export const MAP_UTILITIES_VEHICLE_LIST_GET_UNIT = "MAP_UTILITIES_VEHICLE_LIST_GET_UNIT";
export const MAP_UTILITIES_VEHICLE_LIST_GET_UNIT_RESPONSE = "MAP_UTILITIES_VEHICLE_LIST_GET_UNIT_RESPONSE";
export const MAP_UTILITIES_VEHICLE_LIST_GET_TAG_UNIT = "MAP_UTILITIES_VEHICLE_LIST_GET_TAG_UNIT";
export const MAP_UTILITIES_VEHICLE_LIST_GET_TAG_UNIT_RESPONSE = "MAP_UTILITIES_VEHICLE_LIST_GET_TAG_UNIT_RESPONSE";
